import Service from 'react-reservice';

import { ISymbolTopicLivePrices } from '@aqx-core/common/socket/subscriptions';

export interface ISymbolPriceContext {
  mappedSymbolPrices: Record<string, ISymbolTopicLivePrices>;
}

const defaultContext: ISymbolPriceContext = {
  mappedSymbolPrices: {}
};

class SymbolPriceService extends Service<ISymbolPriceContext> {
  constructor() {
    super();
    this.context = defaultContext;
  }

  setMappedSymbolPrices = (values: Record<string, ISymbolTopicLivePrices>) => {
    this.context.mappedSymbolPrices = { ...values };
  };

  setMappedSymbolPricesPartial = (updates: Record<string, ISymbolTopicLivePrices>) => {
    this.context.mappedSymbolPrices = { ...this.context.mappedSymbolPrices, ...updates };
  };
}

export const symbolPriceService = new SymbolPriceService();
